var widget_default = {
  "card": "lP173",
  "link": "dZhu5",
  "container": "vwEPi",
  "image": "a0lvC",
  "right": "UUYWN",
  "cardLayout": "HLy78",
  "content": "TI5TT",
  "title": "vkZmW",
  "subtitle": "k0Lqp",
  "button": "_8oVmF",
  "button_disabled": "y8Xka",
  "buttonText": "XPQvR",
  "slimLayout": "piO50",
  "contentText": "gRCr4"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
